var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9986 17.1797C28.9107 17.1832 25.9503 18.4114 23.7668 20.5949C21.5833 22.7784 20.3551 25.7388 20.3516 28.8267C20.3516 38.7929 30.9398 46.3198 31.3911 46.6348C31.5692 46.7595 31.7813 46.8264 31.9986 46.8264C32.216 46.8264 32.4281 46.7595 32.6061 46.6348C33.0574 46.3198 43.6457 38.7929 43.6457 28.8267C43.6422 25.7388 42.414 22.7784 40.2305 20.5949C38.047 18.4114 35.0865 17.1832 31.9986 17.1797ZM31.9986 24.5915C32.8363 24.5915 33.6551 24.8398 34.3516 25.3052C35.0481 25.7706 35.591 26.4321 35.9115 27.206C36.2321 27.9799 36.316 28.8314 36.1525 29.653C35.9891 30.4746 35.5857 31.2292 34.9934 31.8215C34.4011 32.4139 33.6465 32.8172 32.8249 32.9807C32.0033 33.1441 31.1517 33.0602 30.3778 32.7396C29.6039 32.4191 28.9425 31.8762 28.4771 31.1797C28.0117 30.4833 27.7633 29.6644 27.7633 28.8267C27.7633 27.7035 28.2095 26.6262 29.0038 25.8319C29.7981 25.0377 30.8754 24.5915 31.9986 24.5915Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCardIcon);
export default __webpack_public_path__ + "static/media/locationCardIcon.7e4130e97424ddfb151de8d95afa26bc.svg";
export { ForwardRef as ReactComponent };